  export const patternPhone = {
    value: /^0\d{0,9}$/,
    message: "Số điện thoại không đúng"
  }
  export const patternNumber = /[^0-9]/